module.exports = __webpack_public_path__ + "static/media/login-screen-image.4e55ba20.png";